import React from 'react';
import LectureRegisterComponent from '../../../components/admin/class/LectureRegisterComponent';

const LectureRegister: React.FC = () => {
  return <LectureRegisterComponent />;
};

export default LectureRegister;
